// extracted by mini-css-extract-plugin
export default {"linksSection":"PC-z"};